import { render, staticRenderFns } from "./ConsultasDetalheDadosLicitacao.vue?vue&type=template&id=26b0ee0a"
import script from "./ConsultasDetalheDadosLicitacao.vue?vue&type=script&lang=js"
export * from "./ConsultasDetalheDadosLicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports